import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ORDER_STATUS_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { OrderStatusBlockScenarioContent } from '@front-platform/content-builder';
import { DoodOrderModel } from '@store/order/order.model';

import {
  ORDER_STATUS_BLOCK_LOADING_VM,
  OrderStatusBlockDataSource,
  OrderStatusBlockViewModel,
} from './order-status-block-view-model';

@Injectable()
export class OrderStatusBlockPreviewDataSource implements OrderStatusBlockDataSource {
  readonly vm$: Observable<OrderStatusBlockViewModel> = previewScenarioForBloc$(
    ORDER_STATUS_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return ORDER_STATUS_BLOCK_LOADING_VM;
      }

      const content = previewScenarioData<OrderStatusBlockScenarioContent>(
        scenario,
        ORDER_STATUS_BLOCK_COMPONENT,
      );
      if (!content) {
        return ORDER_STATUS_BLOCK_LOADING_VM;
      }

      return {
        orders: content.orders as unknown as readonly DoodOrderModel[],
        onSiteLocationName: content.onSiteLocationName,
      };
    }),
  );
}
